<dspx-card-set-base-with-header-form
                         [formServiceEndpoint]="formServiceEndpoint"
                         [fieldTypeReplacements]="fieldTypeReplacements"
                         [verticalNavigationSettings] = "verticalNavigationSettings"
                         [formHeaderModel]="formHeaderModel"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [entityId]="id"
                         formName="Non Mains Medical Cooling Concession Application"
                         (onButtonClick)="buttonClick($event)"
                         (onActionButtonClick)="actionButtonClick($event)"
                         (onDialogSubmit)="dialogSubmit($event)"
                         (onFilter)="filter($event)"
                         (onFormLoad)="formLoaded($event)"
                         (onModelChange)="modelChange($event)"
                         (onSave)="save($event)"
                         (onCancel)="cancel($event)">
</dspx-card-set-base-with-header-form>
